import { render, staticRenderFns } from "./VacancyCard.vue?vue&type=template&id=526a676c&scoped=true&"
import script from "./VacancyCard.vue?vue&type=script&lang=js&"
export * from "./VacancyCard.vue?vue&type=script&lang=js&"
import style0 from "./VacancyCard.vue?vue&type=style&index=0&id=526a676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a676c",
  null
  
)

/* custom blocks */
import block0 from "./VacancyCard.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyCard.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VDivider,VRow})
